// extracted by mini-css-extract-plugin
export default {"hero-logo":"Hero_hero-logo__5GNCK","bgimg":"Hero_bgimg__WLvj0","picTextContainer":"Hero_picTextContainer__d4pu0","textContainer":"Hero_textContainer__TzWL2"};